import React, { useState } from 'react'
import { TextArea as Area, TextAreaChangeEvent } from '@progress/kendo-react-inputs';
import { Error, Label } from '@progress/kendo-react-labels';

interface ITextArea {
  title?: any;
  value?: string;
  size?: 'small' | 'medium' | 'large';
  width?: 'small' | 'medium' | 'large';
  onChange?: (value: string) => void;
  fullwidth?: boolean;
  rows?: number;
  required?: boolean;
  readOnly?: boolean;
}

/**
 * @description Text area component built off kendo-react
 * @param title string? - Used as label shown above text area
 * @param value string? - Used for pre-populating the text area
 * @param size string? - "small" | "medium" | "large" uses kendo built in height "size"
 * @param width string? - "small" | "medium" | "large" sets width of text area
 * @param onChange (value: string) => void? - returns changed value to parent
 * @param fullwidth boolean? - sets width to 100%
 * @param rows number? - sets the number of rows the text area has by default
 * @param required boolean? - prints required text below text area when empty
 * @returns React.Component
 */
const TextArea = (props: ITextArea) => {
  const { title, value, size, fullwidth, width, rows, readOnly, required } = props;
  const [textValue, setTextValue] = useState<string>(value ?? '');
  const [style] = useState<string>(fullwidth ? '100%' : size === 'large' ? '60%' : size === 'medium' ? '40%' : '30%')

  const onChange = (event: TextAreaChangeEvent) => {
    if (props.onChange) {
      setTextValue(event.value);
      props.onChange(event.value);
    } else {
      setTextValue(event.value);
    }
  }

  return (
    <>
      <div style={{display:'flex',flexDirection:'row'}}>
        <div>
          <Label editorId={title}>{title}</Label>
        </div>
        {(!textValue && required) && <Error id={title ?? 'unknown'}>This field is required.</Error>}
      </div>
      <Area
        value={textValue ?? ''}
        size={size ?? 'medium'}
        onChange={onChange}
        style={{ width: style }}
        rows={rows ?? 3}
        readOnly={readOnly ?? false}
      />
    </>
  )
}

export default TextArea